const primary = '#212121';


export default {
  primary,
}